import Swiper from 'swiper';

window.addEventListener('DOMContentLoaded', function () {
  /* TABS */

  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');

  if (0 < tabBtns.length) {
    // display first tab on init
    const firstTabID = tabBtns[0].getAttribute('data-tab');
    tabBtns[0].classList.add('active');
    document.getElementById(firstTabID).classList.add('opened');

    // change on click
    tabBtns.forEach(function (tabBtn) {
      tabBtn.addEventListener('click', function () {
        const tabID = tabBtn.getAttribute('data-tab');
        tabContents.forEach((tabContent) =>
          tabContent.classList.remove('opened')
        );
        tabBtns.forEach((btn) => btn.classList.remove('active'));
        document.getElementById(tabID).classList.add('opened');
        tabBtn.classList.add('active');
      });
    });
  }

  /* FIN TABS */

  /* RELATED PRODUCTS CAROUSEL */
  const relatedProductsCarousel = document.querySelector(
    '.related-products__carousel'
  );

  if (relatedProductsCarousel) {
    const slides = relatedProductsCarousel.querySelectorAll('.swiper-slide');
    const args = {
      centerInsufficientSlides: true,
      breakpoints: {
        slidesPerView: 1,
        spaceBetween: 20,
        640: {
          slidesPerView: 2,
          spaceBetween: 80,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 80,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 80,
        },
      },
      Mousewheel: true,
      navigation: {
        prevEl: relatedProductsCarousel.querySelector('.swiper-button-prev'),
        nextEl: relatedProductsCarousel.querySelector('.swiper-button-next'),
      },
      pagination: {
        el: relatedProductsCarousel.querySelector('.swiper-pagination'),
        clickable: true,
      },
    };

    if (1 < slides.length) {
      args.loop = true;
    } else {
      args.loop = false;
      args.watchOverflow = true;
    }

    if (6 < slides.length) {
      args.centeredSlides = true;
    }

    new Swiper(relatedProductsCarousel, args);
  }
  /* FIN RELATED PRODUCTS CAROUSEL */
});

/* PRODUCT GALLERY */

function changeProductMainThumbnail(image) {
  const mainThumbnail = document.getElementById('product-thumbnail');
  const imageURL = image.getAttribute('data-image');
  const imageALT = image.getAttribute('data-alt');
  mainThumbnail.setAttribute('src', imageURL);
  mainThumbnail.setAttribute('alt', imageALT);
  document
    .querySelectorAll('.product-gallery__thumbnails__thumbnail')
    .forEach(function (thumbnail) {
      thumbnail.classList.remove('active');
    });
  image.classList.add('active');
}

function scrollToThumbnail() {
  if (768 > window.innerWidth) {
    let topScroll = 0;
    const offset = 40;
    const container = document.getElementById('product-content');

    if (container) {
      const thumbnailPosition = container.getBoundingClientRect();
      topScroll = thumbnailPosition.top - offset;
    } else {
      topScroll = offset;
    }

    window.scrollTo({ top: topScroll });
  }
}

window.addEventListener('DOMContentLoaded', function () {
  const galleryThumbnails = document.querySelectorAll(
    '.product-gallery__thumbnails__thumbnail'
  );
  const nutritionTabBtn = document.querySelector('.tab-nutrition');

  if (0 < galleryThumbnails.length) {
    changeProductMainThumbnail(galleryThumbnails[0]);

    galleryThumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        changeProductMainThumbnail(thumbnail);
      });
    });
  }

  if (nutritionTabBtn) {
    nutritionTabBtn.addEventListener('click', function () {
      const thumbnail = document.querySelector(
        '.product-gallery__thumbnails__thumbnail.thumbnail-nutrition'
      );
      if (thumbnail) {
        changeProductMainThumbnail(thumbnail);
        scrollToThumbnail();
      }
    });
  }
});

/* FIN PRODUCT GALLERY */
